import { render, staticRenderFns } from "./CMCourseConfig.vue?vue&type=template&id=d7d98dd0&scoped=true&lang=pug&"
import script from "./CMCourseConfig.vue?vue&type=script&lang=js&"
export * from "./CMCourseConfig.vue?vue&type=script&lang=js&"
import style0 from "./CMCourseConfig.vue?vue&type=style&index=0&id=d7d98dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d98dd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDialog,VIcon,VSkeletonLoader,VSpacer,VTextarea,VTooltip})
